import React from 'react';

const inputName = (name, groupName) => (
  groupName && groupName !== '' ? `${groupName}[${name}]` : name
);

const CheckboxInput = props => {
  const {
    inputId,
    name,
    groupName,
    value,
    onChange,
    checked,
    defaultChecked,
    inputClassName,
    disabled,
  } = props;

  return (
    <input
      type="checkbox"
      id={inputId}
      name={inputName(name, groupName)}
      value={value}
      onChange={onChange}
      checked={checked}
      defaultChecked={defaultChecked}
      className={inputClassName}
      disabled={disabled} />
  );
};

CheckboxInput.defaultProps = {
  groupName: 'parameters',
  name: '',
  checked: false,
};

export default CheckboxInput;
